__turbopack_context__.v({
  "captions": "course-caption-details-module-scss-module__XOPkka__captions",
  "expanded": "course-caption-details-module-scss-module__XOPkka__expanded",
  "first-row": "course-caption-details-module-scss-module__XOPkka__first-row",
  "language-display": "course-caption-details-module-scss-module__XOPkka__language-display",
  "more-button": "course-caption-details-module-scss-module__XOPkka__more-button",
  "second-row": "course-caption-details-module-scss-module__XOPkka__second-row",
});
